import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ReferralPanel } from "@/components/referrals/ReferralPanel";
import { PartnerShell, Notice } from "@/pages/partners/PartnerShell";
import { api, errMsg } from "@/lib/api";

export default function PartnerPanel() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(() => api.get(`/public/partners/panel/${token}`).then((r) => setData(r.data)).catch((e) => setError(errMsg(e))), [token]);
  useEffect(() => { load(); }, [load]);
  const savePix = async (pix_key) => { await api.put(`/public/partners/panel/${token}/pix`, { pix_key }); await load(); };
  return (
    <PartnerShell>
      {error ? <Notice testId="partner-panel-error" title="Não foi possível abrir o painel" text={error}><Link to="/parceiros/entrar" className="text-sm text-primary underline">Receber o link no meu e-mail</Link></Notice>
        : !data ? <p className="text-sm text-muted-foreground">Carregando...</p> : (
          <>
            <div>
              <h1 className="font-display text-2xl font-bold" data-testid="partner-panel-title">Olá, {data.referrer.name.split(" ")[0]}!</h1>
              <p className="text-sm text-muted-foreground">{data.referrer.email}</p>
            </div>
            <ReferralPanel data={data} onSavePix={savePix} />
          </>
        )}
    </PartnerShell>
  );
}
